export default "__VITE_ASSET__B1t4Qu_U__"